import { toast } from "react-toastify";

import { sendRequest } from "../../libs/axiosConfig";
import { errMsg, setToken } from "../../utils/helperFunction";
import {
  emailCheckApi,
  getEarlyBirdOfferApi,
  getExpertsApi,
  getPeerRequestApi,
  getUserDetailApi,
  loginApi,
  loginGoogleApi,
  logoutApi,
  peerRequestApi,
  refreshUserApi,
  updateUserProfileApi,
  userRegisterApi,
  chatBotApi,
  getexpertDetailProfileApi,
  chatBotsmeApi,
  sectorSummaryApi,
  userModuleApi,
  startSessionApi, endSessionApi,
  npsApi,adminNpsApi
} from "../../api/userApi";

// export const loginUser =
//   ({ email, pswd: password }, navigate,from) =>
//   async (dispatch) => {
//     try {
//       dispatch({
//         type: "USER_LOGIN_REQ",
//       });
//       const res = await loginApi({ email, password });

//       dispatch({
//         type: "USER_LOGIN_SUC",
//         payload: res,
//       });

//       // if (data.role === "agency") {
//       //   localStorage.setItem("isAuthenticatedUser", true);
//       //   localStorage.setItem('type', 'agency')
//       //   // navigate(`/agency/practice-dashboard`);
//       //   navigate("/agency/industry/20/industry-activity");
//       // } else if (data.role === "client") {
//       //   localStorage.setItem("type", "client");
//       //   const dataObj = { client: { ...data } };
//       //   dispatch({
//       //     type: "GET_ORG_DETAILS_SUCCESS",
//       //     payload: dataObj,
//       //   });
//       //   navigate(`/client/${data.id}/sme-background`);
//       // }
//       console.log("====login usr", res);

//       if (res.status) {
//         const userData = res.data;
//         setToken(userData.token);
//         // dispatch(getUserModules());
//         if (userData?.user_type === "client") {
//           if (userData.client && userData.client?._id) {
//             navigate(`/client/${userData.client._id}/sme-background`);
//           } else {
//             navigate(`/client/add`);
//           }
//         } else if (userData?.user_type === "expert") {
//           navigate(`/user/expertprofile`);
//         }{
//           // console.log("LOGIN ACTION REDIRECT TO:", from);
//           navigate(from || "/home");
//           // navigate(`/dashboard`);
//         }
//         toast.success(`Welcome back ${userData.full_name}`, {
//           toastId: userData.id,
//           position: "bottom-center",
//         });
        
//       } else {
//         navigate(`/client/add`);
//       }
//     } catch (err) {
//       const message = errMsg(err);
//       toast.error(message, {
//         toastId: message,
//         position: "bottom-center",
//       });
//       dispatch({
//         type: "USER_ERROR",
//         payload: { error: true, message },
//       });
//     }
//   };

export const loginUser =
  ({ email, pswd: password }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "USER_LOGIN_REQ",
      });

      const res = await loginApi({ email, password });

      dispatch({
        type: "USER_LOGIN_SUC",
        payload: res,
      });

    } catch (err) {
      dispatch({
        type: "USER_ERROR",
      });
    }
  };
export const refreshUserWithoutNavigate = () => async (dispatch) => {
  try {
    dispatch({
      type: "USER_LOGIN_REQ",
    });

    const data = await refreshUserApi();

    dispatch({
      type: "USER_REFRESH_LOGIN_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);
    dispatch({
      type: "USER_ERROR",
      payload: { error: true, message },
    });
  }
};

export const refreshUser = (navigate, isFirstLogin) => async (dispatch) => {
  if (isFirstLogin) {
    try {
      dispatch({
        type: "REFRESH_LOGIN_REQ",
      });

      const { data } = await sendRequest({
        url: `/api/v1/user/refresh-user-session`,
        method: "GET",
      });

      if (data.role === "agency") {
        dispatch({
          type: "REFRESH_LOGIN_SUC",
          payload: data,
        });

        navigate(`/agency`);
      } else if (data.role === "client") {
        const dataObj = { client: { ...data } };
        dispatch({
          type: "GET_ORG_DETAILS_SUCCESS",
          payload: dataObj,
        });

        dispatch({
          type: "REFRESH_LOGIN_SUC",
          payload: data,
        });

        navigate(`/client/${data.id}/sme-background`);
      }

      /* dispatch({
        type: "REFRESH_LOGIN_SUC",
      }); */
    } catch (err) {
      const message = errMsg(err);

      if (message === "Authorization Failed : jwt expired") {
        return dispatch(logoutAgency(navigate));
      }

      toast.error(message, {
        toastId: message,
        position: "bottom-center",
      });

      dispatch({
        type: "REFRESH_LOGIN_FAIL",
        payload: { error: true, message },
      });
    }
  }
};

export const logoutAgency = (navigate) => async (dispatch) => {
  try {
    dispatch({
      type: "LOGOUT_USER_REQ",
    });

    const { message } = await logoutApi();

    dispatch({
      type: "LOGOUT_USER_SUCCESS",
    });

    navigate(`/`);

    toast.success(message, {
      toastId: "log-out-succ",
      position: "bottom-center",
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "LOGOUT_USER_FAIL",
      payload: { error: true, message },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const loginGoogleUser = (codeResponse, navigate) => async (dispatch) => {
  try {
    dispatch({
      type: "USER_LOGIN_REQ",
    });
    const data = await loginGoogleApi(codeResponse);

    setToken(data.token);

    dispatch({
      type: "USER_LOGIN_SUC",
      payload: data,
    });

    if (data.role === "agency") {
      navigate(`/agency/practice-dashboard`);
    } else if (data.role === "client") {
      const dataObj = { client: { ...data } };
      dispatch({
        type: "GET_ORG_DETAILS_SUCCESS",
        payload: dataObj,
      });
      navigate(`/client/${data.id}/sme-background`);
    }

    toast.success(`Welcome back ${data.full_name}`, {
      toastId: data.id,
      position: "bottom-center",
    });
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });

    dispatch({
      type: "USER_LOGIN_FAIL",
      payload: { error: true, message },
    });
  }
};

export const emailCheck =
  ({ email }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "USER_REQ",
      });

      const data = await emailCheckApi({ email });

      dispatch({
        type: "USER_EMAIL_EXIST_SUC",
        payload: data,
      });
      if (data.status) {
        toast.error(data.message, {
          toastId: data.message,
          position: "bottom-center",
        });
      }
    } catch (err) {
      const message = errMsg(err);

      toast.error(message, {
        toastId: message,
        position: "bottom-center",
      });

      dispatch({
        type: "USER_ERROR",
        payload: { error: true, message },
      });
    }
  };

export const logout = (navigate) => async (dispatch) => {
  try {
    dispatch({
      type: "USER_LOGOUT_REQ",
    });

    const { message } = await logoutApi();

    dispatch({
      type: "USER_LOGOUT_SUCCESS",
    });

    navigate(`/`);

    toast.success(message, {
      toastId: "log-out-succ",
      position: "bottom-center",
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_ERROR",
      payload: { error: true, message },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const userRegister =
  (
    {
      email,
      designation,
      mobileno,
      full_name,
      password,
      isCA,
      mrn,
      companyName,
      companyAddressLine1,
      companyAddressLine2,
      userType,
      sectorCategory,
      products,
      firstName,
      lastName,
      caseStudies,
      schedulingLink
    },
    navigate
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "USER_REQ",
      });
      const reqBody = {
        full_name,
        email,
        password,
        mobileno,
        designation,
        isCA,
        mrn,
        companyName,
        companyAddressLine1,
        companyAddressLine2,
        userType,
        sectorCategory,
        products,
        firstName,
        lastName,
        caseStudies,
        schedulingLink
      };
      const data = await userRegisterApi(reqBody);

      dispatch({
        type: "USER_REGISTER_SUC",
        payload: data,
      });
      // navigate the user to ,login page after registration
      navigate("/login");
      toast.success(`Thanks for registering`, {
        toastId: "USER_REGISTER",
        position: "bottom-center",
      });
    } catch (err) {
      const message = errMsg(err);

      dispatch({
        type: "USER_ERROR",
        payload: {
          error: true,
          message,
        },
      });

      toast.error(message, {
        toastId: message,
        position: "bottom-center",
      });
    }
  };

export const peerRequest = (reqBody) => async (dispatch) => {
  try {
    dispatch({
      type: "USER_PEER_REQUEST_REQ",
    });
    const data = await peerRequestApi(reqBody);

    dispatch({
      type: "USER_PEER_REQUEST_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_PEER_REQUEST_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const getPeerRequest = () => async (dispatch) => {
  try {
    dispatch({
      type: "USER_PEER_REQUEST_REQ",
    });
    const data = await getPeerRequestApi();

    dispatch({
      type: "USER_PEER_REQUEST_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_PEER_REQUEST_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const updateUserProfile = (reqBody) => async (dispatch) => {
  try {
    dispatch({
      type: "USER_PROFILE_REQ",
    });
    const data = await updateUserProfileApi(reqBody);

    dispatch({
      type: "USER_PROFILE_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_PROFILE_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const getUserDetail = (reqBody) => async (dispatch) => {
  try {
    dispatch({
      type: "USER_PROFILE_REQ",
    });
    const data = await getUserDetailApi(reqBody);

    dispatch({
      type: "USER_PROFILE_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_PROFILE_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const getExperts = (reqBody) => async (dispatch) => {
  try {
    dispatch({
      type: "USER_EXPERT_REQ",
    });
    const data = await getExpertsApi(reqBody);

    dispatch({
      type: "USER_EXPERT_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_EXPERT_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};


export const getEarlyBirdOffer = () => async (dispatch) => {
  try {
    dispatch({
      type: "USER_EARLY_BIRD_OFFER_REQ",
    });
    const data = await getEarlyBirdOfferApi();

    dispatch({
      type: "USER_EARLY_BIRD_OFFER_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_EARLY_BIRD_OFFER_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const getchatBot = (message, userId) => async (dispatch) => {
  try {
    dispatch({ type: "USER_CHATBOT_REQ" });
    const data = await chatBotApi({ message, userId });
    dispatch({
      type: "USER_CHATBOT_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);
    dispatch({
      type: "USER_CHATBOT_ERROR",
      payload: {
        error: true,
        message,
      },
    });
  }
};


export const getExpertDetailProfile = (expertId) => async (dispatch) => {
  try {
    dispatch({ type: "EXPERT_PROFILE_REQ" });

    const response = await getexpertDetailProfileApi(expertId); // Make sure your API function accepts expertId
    
    dispatch({
      type: "EXPERT_PROFILE_FETCH_SUC",
      payload: {
        status: response?.status || 200,
        message: "Success",
        data: response?.data || response || [] // Adjust based on your API response structure
      }
    });

  } catch (err) {
    const message = errMsg(err);
    dispatch({
      type: "EXPERT_PROFILE_ERROR",
      payload: {
        error: true,
        message,
      },
    });
  }
};

export const fetchChatbotResponse = (message, sectorName) => async (dispatch, getState) => {
  try {
    dispatch({ type: "CHATBOT_REQ" });

    const userId = getState().userReducer?.data?._id;  // assuming userId is stored here

    const res = await chatBotsmeApi({
      message,
      sectorName,
      userId
    });
console.log("API response data:", res.data);
    dispatch({
      type: "CHATBOT_FETCH_SUC",
      payload: res.data  //  pass full res.data to reducer
    });

  } catch (error) {
    console.error("Chatbot Error:", error);
    dispatch({
      type: "CHATBOT_ERROR",
      payload: { error: error.message }
    });
  }
};

// sectorSummaryActions.js



export const fetchSectorSummary = (sectorName) => async (dispatch) => {
  try {
    dispatch({ type: "SECTORS_REQ", payload: { sectorName } });

    const res = await sectorSummaryApi({ sectorName });

  dispatch({
  type: "SECTORS_FETCH_SUC",
  payload: {
    status: "success",  
    message: "Sector Summary fetched successfully",
    data: res
  }
});
console.log("API Response: ", res);


  } catch (error) {
    console.error("Sector Summary Fetch Error:", error);
    dispatch({
      type: "SECTORS_ERROR",
      payload: {
        message: "Failed to fetch sector summary",
        error: error?.message || "Unknown error"
      }
    });
  }
};

export const getUserModules = () => async (dispatch) => {
  try {
    dispatch({
      type: "USER_MODULE_REQ",
    });
    const data = await userModuleApi();

    dispatch({
      type: "USER_MODULE_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_MODULE_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};



export const startSession = (userId, reqBody) => async (dispatch) => {
  try {
    dispatch({ type: "SESSION_START_REQ", meta: { userId } });

    const data = await startSessionApi(reqBody);

    dispatch({
      type: "SESSION_START_SUC",
      meta: { userId },
      payload: data,
    });

    return data;
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "SESSION_START_ERR",
      meta: { userId },
      payload: { error: true, message },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });

    throw err;
  }
};

export const endSession = (userId, reqBody) => async (dispatch) => {
  try {
    dispatch({ type: "SESSION_END_REQ", meta: { userId } });

    const data = await endSessionApi(reqBody);

    dispatch({
      type: "SESSION_END_SUC",
      meta: { userId },
      payload: data,
    });

    return data;
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "SESSION_END_ERR",
      meta: { userId },
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });

    throw err;
  }
};


export const answerNps = (userId, reqBody) => async (dispatch) => {
  dispatch({ type: "NPS_ANSWER_REQ" });

  const data = await npsApi(reqBody);

  dispatch({
    type: "NPS_ANSWER_SUC",
    payload: data,
    meta: { userId },
  });

  return data;
};


export const fetchAdminNps = () => async (dispatch) => {
  dispatch({ type: "ADMIN_NPS_REQ" });

  try {
    const res = await adminNpsApi();

    dispatch({
      type: "ADMIN_NPS_SUC",
      payload: {
        status: res.status,
        message: res.message,
        data: res.data, 
      },
    });

    return res;
  } catch (error) {
    dispatch({
      type: "ADMIN_NPS_ERR",
      payload: {
        message: error?.message || "Failed to fetch admin NPS",
      },
    });
    throw error;
  }
};
